module.exports = __webpack_public_path__ + "static/media/MuseoSansBlack.9d94b7ea.eot";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/MuseoSansBlack/MuseoSansBlack.eot
// module id = 243
// module chunks = 0